const HisPersonCheck = ({ color, sx }) => {
  const strokeColor = color ?? '#708FBB';
  let _sx = sx ?? {};
  return (
    <svg style={_sx} width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.0772 28.0995V25.0885C22.0772 23.4913 21.4427 21.9596 20.3134 20.8302C19.184 19.7009 17.6523 19.0664 16.0551 19.0664H7.02205C5.4249 19.0664 3.89317 19.7009 2.76382 20.8302C1.63446 21.9596 1 23.4913 1 25.0885V28.0995"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M11.5396 13.0441C14.8655 13.0441 17.5617 10.3479 17.5617 7.02205C17.5617 3.69616 14.8655 1 11.5396 1C8.21374 1 5.51758 3.69616 5.51758 7.02205C5.51758 10.3479 8.21374 13.0441 11.5396 13.0441Z"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M22.0762 13.0442L25.0872 16.0553L31.1092 10.0332" stroke={strokeColor} stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default HisPersonCheck;